import { MarkerSize } from './types';

export const markerSizeToWidth: Record<MarkerSize, number> = {
  m: 12,
  s: 2,
};
